import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail } from 'lucide-react';
export function BlogPostPage() {
  return <div className="min-h-screen bg-white" data-id="element-686">
      {/* Header */}
      <Header variant="solid" data-id="element-687" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-688">
        <div className="max-w-4xl mx-auto" data-id="element-689">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-690">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-691">
              News & Events
            </a>
            <span className="mx-2" data-id="element-692">/</span>
            <span className="text-neutral-900" data-id="element-693">
              Peterson House Bubbleologist Experience
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-694">
            Peterson House Bubbleologist Experience
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-695">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Gelato-tasting-Peterson-House.jpg" alt="Peterson House Bubbleologist Experience" className="w-full h-full object-cover" data-id="element-696" />
          </div>

          {/* Content */}
          <article className="prose prose-lg max-w-none" data-id="element-697">
            <p className="text-neutral-600 text-lg leading-relaxed mb-6" data-id="element-698">
              Since 2017 Peterson House has been hosting 'Bubbleologist
              Experience'. A special members event that allows our members to
              visit behind the scenes of bubble making!
            </p>

            <h2 className="font-heading text-3xl text-neutral-900 mt-12 mb-6" data-id="element-699">
              So what is Bubbleologist?
            </h2>

            <div className="bg-neutral-50 border-l-4 border-brand-pink p-8 my-8" data-id="element-700">
              <p className="text-neutral-700 text-lg leading-relaxed italic mb-4" data-id="element-701">
                "Bubbleologist Experience is like no other experience in the
                Hunter Valley. We meet at Peterson House and board the bus to
                head to our production facility. Our chief wine maker, John
                Reid, greets you with a glass of bubbles and begins to explain
                the process of making sparkling wine. Next, you start creating
                your own unique blend of bubbles!"
              </p>
              <p className="text-neutral-600 text-sm font-medium" data-id="element-702">
                — Sally Chrystal, Wine Club Manager
              </p>
            </div>

            <p className="text-neutral-600 text-lg leading-relaxed mb-6" data-id="element-703">
              When you have finalised your designer bubbles, John will complete
              the final product while you head back to Peterson House award
              winning, Restaurant Cuvee for a decadent four-course lunch.
            </p>

            {/* Pricing Section */}
            <div className="bg-white border border-neutral-200 p-8 my-12" data-id="element-704">
              <h3 className="font-heading text-2xl text-neutral-900 mb-6" data-id="element-705">
                Experience Details
              </h3>

              <div className="mb-6" data-id="element-706">
                <p className="text-3xl font-heading text-brand-pink mb-2" data-id="element-707">
                  $450 per couple
                </p>
                <p className="text-neutral-600 text-sm" data-id="element-708">(shared experience)</p>
              </div>

              <h4 className="font-medium text-neutral-900 mb-4" data-id="element-709">
                What's Included:
              </h4>
              <ul className="space-y-3 mb-8" data-id="element-710">
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-711">
                  <span className="text-brand-pink mt-1" data-id="element-712">•</span>
                  <span data-id="element-713">A bottle of your special blend of bubbles</span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-714">
                  <span className="text-brand-pink mt-1" data-id="element-715">•</span>
                  <span data-id="element-716">A Bubbleologist apron</span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-717">
                  <span className="text-brand-pink mt-1" data-id="element-718">•</span>
                  <span data-id="element-719">Four-course meal with wine matching</span>
                </li>
                <li className="flex items-start gap-3 text-neutral-600" data-id="element-720">
                  <span className="text-brand-pink mt-1" data-id="element-721">•</span>
                  <span data-id="element-722">Heaps of fun!</span>
                </li>
              </ul>

              <p className="text-neutral-700 font-medium mb-6" data-id="element-723">
                Numbers are strictly limited so book early to avoid
                disappointment.
              </p>

              {/* Booking CTA */}
              <div className="bg-neutral-50 p-6 space-y-4" data-id="element-724">
                <h4 className="font-heading text-xl text-neutral-900 mb-4" data-id="element-725">
                  Book Your Experience
                </h4>
                <div className="space-y-3" data-id="element-726">
                  <a href="tel:+61249987881" className="flex items-center gap-3 text-neutral-900 hover:text-brand-pink transition-colors" data-id="element-727">
                    <Phone className="w-5 h-5 text-brand-pink" data-id="element-728" />
                    <span className="font-medium" data-id="element-729">(02) 4998 7881</span>
                  </a>
                  <a href="mailto:club@petersonhouse.com.au" className="flex items-center gap-3 text-neutral-900 hover:text-brand-pink transition-colors" data-id="element-730">
                    <Mail className="w-5 h-5 text-brand-pink" data-id="element-731" />
                    <span className="font-medium" data-id="element-732">
                      club@petersonhouse.com.au
                    </span>
                  </a>
                </div>
              </div>
            </div>

            {/* Back to Blog */}
            <div className="mt-12 pt-8 border-t border-neutral-200" data-id="element-733">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-734">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-735" />
    </div>;
}